import { toaster } from '@/components/ui/toaster';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

/** The marker the backend adds when Shopify sends the brand back with its store connected. */
const CONNECTED_MARKER = 'shopify';

/**
 * Says the store is connected when Shopify sends the brand back, wherever the
 * guards land it (the dashboard, or the plan choice on top of it), then drops
 * the marker so a reload or a shared link never says it twice.
 */
export const ShopifyConnectedToast = () => {
  const { t } = useTranslation();
  const [params, setParams] = useSearchParams();
  const shown = useRef(false);
  const connected = params.get(CONNECTED_MARKER) === 'connected';

  useEffect(() => {
    if (!connected || shown.current) return;
    shown.current = true;
    toaster.success({
      title: t('integrations.shopify.connectedToast.title'),
      description: t('integrations.shopify.connectedToast.description'),
    });
    setParams(
      (current) => {
        const next = new URLSearchParams(current);
        next.delete(CONNECTED_MARKER);
        return next;
      },
      { replace: true }
    );
  }, [connected, setParams, t]);

  return null;
};
